module.exports = __webpack_public_path__ + "img/E.35d47951.svg";